import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { Cart } from 'pages/cart/cart';

export default function CartPage() {
  useRumPageView('cart', 'Cart');
  return <Cart />;
}
